/**
 * MobileNavContext — shares the mobile drawer's open state between the
 * persistent `Sidenav` (in `ShellLayout`) and the per-page `AppShell` header
 * (which owns the hamburger button).
 *
 * On desktop the sidenav is a static grid column and this state is inert; on
 * ≤900px the `open` flag adds the `.open` class that slides the drawer in.
 *
 * Defaults to a no-op so an `AppShell` rendered outside a provider (tests,
 * standalone stories) still works — the hamburger simply does nothing.
 */
import React, { createContext, useContext } from 'react';

interface MobileNavValue {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const MobileNavContext = createContext<MobileNavValue>({ open: false, setOpen: () => {} });

export function MobileNavProvider({ value, children }: { value: MobileNavValue; children: React.ReactNode }) {
  return <MobileNavContext.Provider value={value}>{children}</MobileNavContext.Provider>;
}

export function useMobileNav(): MobileNavValue {
  return useContext(MobileNavContext);
}
